import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ScreeningReportNavLink from '../ScreeningReportNavLink';
import BackgroundCheckDisputeAlert from './BackgroundCheckDisputeAlert';
import BackgroundCheckGeneralAlert from './BackgroundCheckGeneralAlert';
import BackgroundCheckNavigation from './BackgroundCheckNavigation';
import { BACKGROUND } from '../../../../../../constants/overviewSections';
import { REPORT_STATUS_NOT_AVAILABLE } from '../../../../../../constants/statusConstants';
import { getIsBackgroundReportUnavailableSelector } from '../../../../../../selectors/sharedReports';
import { isLandlordIdVerifiedSelector } from '../../../../../../selectors';
import BackgroundCheckSecurityFreezeAlert from './BackgroundCheckSecurityFreezeAlert';
import BackgroundCheckManualReviewAlert from './BackgroundCheckManualReviewAlert';
import { useListingUser } from '../../../../../../hooks/useListingUser';
import { emitBackgroundReportLinkEvent } from '../../../../../../../client/analytics/clickstreamEvents';

export default function BackgroundCheckNavLink({
  applicant,
  isCustomLoading,
  customNavigationCallback,
  setCustomNavigationCallback,
}) {
  const { user, listing } = useListingUser();
  const { userId: applicantId } = applicant;
  const isBackgroundReportUnavailable = useSelector(getIsBackgroundReportUnavailableSelector(applicantId));
  const isIdVerified = useSelector(isLandlordIdVerifiedSelector);

  const reportStatus =
    // This call gets made after page load.
    isBackgroundReportUnavailable
      ? REPORT_STATUS_NOT_AVAILABLE
      : // Default to status from application snapshot.
        JSON.parse(applicant?.backgroundStatus || '"{}"').status;

  return (
    <>
      <BackgroundCheckNavigation
        {...{
          applicantId,
          customNavigationCallback,
          setCustomNavigationCallback,
        }}
      />
      <ScreeningReportNavLink
        {...{
          trackNavLinkClick: () => emitBackgroundReportLinkEvent(listing, user),
          applicant,
          sectionComment: applicant.backgroundReportComment,
          reportStatus,
          title: 'Background check',
          sectionId: BACKGROUND,
          alert: (
            <>
              <BackgroundCheckGeneralAlert {...{ applicant }} />
              <BackgroundCheckManualReviewAlert {...{ applicant }} />
              <BackgroundCheckDisputeAlert {...{ applicant }} />
              <BackgroundCheckSecurityFreezeAlert {...{ applicant }} />
            </>
          ),
          ...(isIdVerified && {
            isCustomLoading,
            setCustomNavigationCallback,
          }),
        }}
      />
    </>
  );
}

BackgroundCheckNavLink.displayName = 'BackgroundCheckNavLink';

BackgroundCheckNavLink.propTypes = {
  applicant: PropTypes.shape({
    currentIncome: PropTypes.string.isRequired,
    isComplete: PropTypes.bool.isRequired,
    userId: PropTypes.string.isRequired,
    zgAuthZone: PropTypes.string.isRequired,
    backgroundReportComment: ScreeningReportNavLink.propTypes.sectionComment,
    backgroundInfo: PropTypes.shape({
      status: ScreeningReportNavLink.propTypes.reportStatus,
    }),
    backgroundStatus: PropTypes.string,
  }).isRequired,
  isCustomLoading: PropTypes.bool.isRequired,
  customNavigationCallback: PropTypes.func,
  setCustomNavigationCallback: PropTypes.func.isRequired,
};
